import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminPrivateRoute = ({ children }) => {
  const loggedInUser = useSelector((state) => state.authen.loggedInUser);

  if (!loggedInUser || loggedInUser.status !== "Pass") {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminPrivateRoute;
